
import React from "react";
import { CountyIntroduction } from "@/components/nursing-homes/county/CountyIntroduction";
import { CountyFAQSection } from "@/components/nursing-homes/county/CountyFAQSection";
import { CountyAreasSection } from "@/components/nursing-homes/county/CountyAreasSection";
import { CountyNearbySection } from "@/components/nursing-homes/county/CountyNearbySection";
import { CountyInsightsPanel } from "@/components/nursing-homes/county/CountyInsightsPanel";
import { CountyProvinceLinks } from "@/components/nursing-homes/county/CountyProvinceLinks";
import { CountyAllCountiesSection } from "@/components/nursing-homes/county/CountyAllCountiesSection";

interface ContentSectionsProps {
  countyName: string;
  countySlug: string;
  countyDescription?: string;
  nursingHomeCount: number;
  faqs: { question: string; answer: string }[];
  nearbyCounties: any[];
  allCounties?: { name: string; slug: string; nursing_home_count?: number | null }[];
}

export function ContentSections({
  countyName,
  countySlug,
  countyDescription,
  nursingHomeCount,
  faqs,
  nearbyCounties,
  allCounties = [],
}: ContentSectionsProps) {
  return (
    <div className="space-y-8">
      <CountyIntroduction 
        countyName={countyName} 
        nursingHomeCount={nursingHomeCount}
        description={countyDescription || undefined}
      />

      {/* Perplexity-powered live insights panel */}
      <CountyInsightsPanel countyName={countyName} countySlug={countySlug} />
      
      <CountyFAQSection 
        countyName={countyName}
        faqs={faqs}
      />
      
      <CountyAreasSection
        countyName={countyName}
        countySlug={countySlug}
      />

      {/* Province-based internal linking */}
      <CountyProvinceLinks
        currentCountySlug={countySlug}
        currentCountyName={countyName}
      />
      
      <CountyNearbySection 
        countyName={countyName}
        nearbyCounties={nearbyCounties}
      />

      {/* All-Ireland county cross-linking silo */}
      <CountyAllCountiesSection
        currentCountySlug={countySlug}
        currentCountyName={countyName}
        allCounties={allCounties}
      />
    </div>
  );
}
